// src/App.js
import React from 'react';
import Dashboard from './Dashboard';

function App() {
  return (
    <div>
      <Dashboard />
    </div>
  );
}

export default App;
